export const ACCOUNT_TYPE = {
    DIAMOND_ANNUAL: "diamond.annual.discount",
    FLEET_MONTH: "fleet.month",
};

export const COUNTRY_LIST = [
    {
        code: "US",
        name: "United States",
    },
    {
        code: "CA",
        name: "Canada",
    }
];
